import { Text, Highlight } from "@chakra-ui/react";
import { useTags } from "modules/providers/tags-provider";
import React, { memo } from "react";
import colors from "app/colors";
import { getTagMention } from "modules/utils/Functions";
import useQueryString from "modules/hooks/use-query-string";

interface IProps {
  id: string;
  highlight?: boolean;
}

const TagMention = ({ id, highlight = true }: IProps) => {
  const { tagsById } = useTags();
  const tag = tagsById[id];
  const { qsMessageHighlights } = useQueryString();

  const highlightQuery = highlight ? qsMessageHighlights : "";

  if (!tag) {
    return null;
  }

  if (!tag.active) {
    return (
      <Text
        fontWeight={400}
        color={colors.blackSecondary}
        as="span"
        fontStyle="italic"
      >
        {getTagMention(tag)}
      </Text>
    );
  }

  return (
    <Text fontWeight="semibold" color={colors.blue} as="span">
      <Highlight query={highlightQuery} styles={{ bg: colors.yellow }}>
        {getTagMention(tag)}
      </Highlight>
    </Text>
  );
};

export default memo(TagMention);
